import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class CustomFieldUpdaterService {

    update: EventEmitter<CustomFieldsUpdater> = new EventEmitter();

    constructor() { }
}

export interface CustomFieldsUpdater{
    index?:number;
    value?:any;
}